import React, { createContext, useContext } from "react";
import { buildSignalCategoryTheme } from "@/components/analysisModules/comps/SignalFilters/signalCategories";

/**
 * The Topics view's signal-category theme — built once from the tree's
 * `signalCategories` (the tenant's own vocabulary) and read by every
 * category-coloured piece beneath it (card bars, drilldown sections,
 * sparklines, donut rings, Priorities accents) so none of them has to
 * carry a fixed category list of its own.
 *
 * Outside a provider the hook returns the PM defaults, so a component
 * rendered elsewhere keeps its previous look.
 */
const SignalCategoriesContext = createContext(null);

export const SignalCategoriesProvider = ({ value, children }) => (
  <SignalCategoriesContext.Provider value={value}>{children}</SignalCategoriesContext.Provider>
);

const PM_DEFAULT_THEME = buildSignalCategoryTheme();

export const useSignalCategories = () => useContext(SignalCategoriesContext) || PM_DEFAULT_THEME;
